import React, { useState } from "react";
import LoaderContext from "../loadercontext/LoaderContext";
import "./loader.css";

function LoaderProvider({ children }) {
  const [busy, setBusy] = useState(false);
  return (
    <div>
      <LoaderContext.Provider value={{ busy, setBusy }}>
        {children}
      </LoaderContext.Provider>
      {busy ? (
        <div className="loader">
          <div className="loader-content text-danger">
            Please wait. We are preparing your order.
          </div>
          <div className="centered">
            <div className="rotater"></div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default LoaderProvider;
